import { CustomShadowOptions } from './muiCustom.d';

export const shadows: CustomShadowOptions = {
  clickable: '0px 4px 20px 0px rgba(0, 0, 0, 0.12)',
  header: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
  button: '0px 2px 4px 0px rgba(0, 0, 0, 0.20)',
  navBottom: '0 -3px 2px rgba(0, 0, 0, 0.1)',
  bottomSheet: '0 6px 13px 0 rgba(0, 0, 0, 0.1)',
};
